import { useMemo } from "react";

import { SALES_METRICS_COUNT_V4 } from "@gql/sales-page-v4";
import { useNorthbeamQuery } from "@hooks/http";
import {
  type GetSalesMetricsCountV4,
  type GetSalesMetricsCountV4Variables,
} from "@north-beam/nb-client-side";

export const useSalesMetricsCountQuery = ({
  variables,
  skip = false,
}: {
  variables: GetSalesMetricsCountV4Variables;
  skip?: boolean;
}) => {
  const { data, loading } = useNorthbeamQuery<
    GetSalesMetricsCountV4,
    GetSalesMetricsCountV4Variables
  >(SALES_METRICS_COUNT_V4, { skip, variables });

  const total = useMemo(() => {
    return data?.me.salesMetricsCountV4.total ?? 0;
  }, [data]);

  return { total, loading };
};
